import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const SearchButtonWrapper = styled.div`
  @media (${mediaQuery.tablet}) {
    display: none !important;
  }

  .btn-search {
    cursor: pointer;
    font-weight: 400;
    width: auto;
    padding: 5px 24px;
    border-radius: 3px;
    background-color: #ffffff;
    border: solid 1px #333f48;
    color: #333f48;
    outline: none;

    .text {
      font-size: 16px;
      line-height: 22px;
      margin-left: 8px;
    }

    &.active {
      border-color: #0283cc;
      color: #0283cc;
    }
  }
`;
